{
  "UnifiedNavigation": "In Experience Cloud navigieren",
  "adobeExperienceCloudNoOrgsSelect": "Anderes Unternehmenskonto auswählen",
  "help": "Hilfe",
  "profile": "Profil",
  "searchButton": "Suchen",
  "sidenavMenuCloseTooltip": "Menü schließen",
  "sidenavMenuOpenTooltip": "Menü öffnen",
  "solutionSwitcher": "Zu anderer Lösung wechseln",
  "toggleSideNav": "Navigationsmenü auf der Seite ein/aus"
}
